<template>
  <div style="width: 100%">
    <monitoramento-competencia-tecnica
      :competencias="competencias"
      :unidade="unidade"
      :mapeamento="mapeamento"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MonitoramentoCompetenciaTecnica from '@/components/monitoramento/mapeamento/MonitoramentoCompetenciaTecnica';

export default {
  name: 'MonitoramentoUnidadeCompetenciaTecnica',

  components: { MonitoramentoCompetenciaTecnica },

  props: {
    mapeamento: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState({
      competencias:
        (state) => state.monitoramento.mapeamento.relatorio.competenciasTecnicasConsolidadas.competenciasTecnicas,
      unidade: (state) => state.monitoramento.mapeamento.relatorio.unidade,
    }),
  },
};
</script>
